import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';
import {
  ApplyStyles,
  SummaryAnalyticsEvent
} from '@com-delta-idp/mnx-skymiles-shared';
import { Snapshot } from './models/snapshot.interfaces';

@Component({
  selector: 'idp-snapshot',
  templateUrl: './snapshot.component.html',
  styleUrls: ['./snapshot.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SnapshotComponent implements OnInit {
  @Input() content: Snapshot = {} as Snapshot;
  @Output() analyticsEvent = new EventEmitter<SummaryAnalyticsEvent>();

  dividerStyle: ApplyStyles[] = [] as ApplyStyles[];
  expanderStyle: ApplyStyles[] = [] as ApplyStyles[];
  entryItemStyle: ApplyStyles[] = [] as ApplyStyles[];

  showAccountActivity = false;

  isMobile = false;

  ngOnInit() {
    this.isMobile = window.innerWidth < 768;

    this.dividerStyle = !this.isMobile
      ? [
          {
            targetClass: ['aura-divider'],
            rules: { width: 'unset', margin: '0 30px' }
          }
        ]
      : [
          {
            targetClass: ['aura-divider'],
            rules: { width: 'unset', margin: '0 15px' }
          }
        ];

    this.expanderStyle = !this.isMobile
      ? [
          {
            targetClass: ['aura-toggle-area__wrapper'],
            rules: { 'padding-right': '30px' }
          },
          {
            targetClass: ['aura-entry-item'],
            rules: { 'padding-left': '30px' }
          },
          {
            targetClass: ['aura-entry-item__contents__description__title'],
            rules: {
              'font-size': '20px',
              'line-height': '28px',
              'font-family': 'Whitney-Semibold'
            }
          }
        ]
      : [];

    this.entryItemStyle = !this.isMobile
      ? [
          {
            targetClass: ['aura-entry-item'],
            rules: { padding: '20px 30px' }
          }
        ]
      : [];
  }

  onLinkClick(label: string, url: string): void {
    this.analyticsEvent.emit({
      action: {
        label: label,
        url: url
      },
      eventType: 'click',
      id: 'snapshot'
    });
  }
}
